import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { Icon, Menu, MenuStateProvider } from '@maui/elements'
import { Portal } from '../Portal'

import { RangeSelect } from './RangeSelect'
import { TimeRangeFilterMenuButton } from './TimeRangeFilterMenuButton'
import { defaultOptions, rangeConfigurations } from './options'

// TODO This component performs very poorly and needs work.  It may be because
//      of nested reakit menus (this menu nested RangeMenu)
export const TimeRangeFilter = ({
  editorOptions: options,
  data,
  updateData,
}) => {
  const mergedOptions = { ...defaultOptions, ...options }
  const { defaultValue, valueName, rangeName, ranges } = mergedOptions
  const defaultRange = mergedOptions.defaultRange ?? ranges[0]
  const {
    [valueName]: value = defaultValue,
    [rangeName]: range = defaultRange,
  } = data
  const config = rangeConfigurations[range]
  const label = `Last ${value} ${value === 1 ? config.singular : config.plural}`

  const onCommit = useCallback(({ value, range }) => {
    updateData({
      [valueName]: value === defaultValue ? undefined : value,
      [rangeName]: range === defaultRange ? undefined : range,
    })
  }, [updateData, valueName, rangeName, defaultValue, defaultRange])

  return (
    <MenuStateProvider initialState={{ placement: 'bottom-end' }}>
      <TimeRangeFilterMenuButton display="inline-flex" alignItems="center">
        {label} <Icon name="angle-down" ml="4px" />
      </TimeRangeFilterMenuButton>
      <Portal>
        <Menu overflow="visible">
          <RangeSelect
            value={value}
            range={range}
            onCommit={onCommit}
            ranges={ranges}
          />
        </Menu>
      </Portal>
    </MenuStateProvider>
  )
}

TimeRangeFilter.defaultProps = {
  editorOptions: {},
  data: {},
}

TimeRangeFilter.propTypes = {
  editorOptions: PropTypes.shape({
    ranges: PropTypes.arrayOf(PropTypes.oneOf(defaultOptions.ranges)),
    valueName: PropTypes.string,
    rangeName: PropTypes.string,
  }),
  data: PropTypes.object,
  updateData: PropTypes.func.isRequired,
}
